import request from 'manager/utils/request';
import { REST_SERVICE } from 'manager/config';

const publicUserService = {
  //查询公众用户列表
  publicQueryList(params) {
    return request({
      url: REST_SERVICE.agencyUser.findPublic,
      method: 'get',
      params,
    });
  },
  //查询机构用户列表
  enterpriseQueryList(params) {
    return request({
      url: REST_SERVICE.agencyUser.findInstitutionalUser,
      method: 'get',
      params,
    });
  },

  // 通过loginName查询用户
  findInfoByname(params) {
    return request({
      url: REST_SERVICE.agencyUser.findUser,
      method: 'get',
      params,
    });
  },

  // 通过loginName查询用户
  deleteUserinfoByLoginname(data) {
    return request({
      url: REST_SERVICE.agencyUser.deleteUserinfoByLoginname,
      method: 'post',
      data,
    });
  },

  // 通过loginName查询用户
  getBlackReasonByName(params) {
    return request({
      url: REST_SERVICE.agencyUser.getBlackReasonByName,
      method: 'get',
      params,
    });
  },

  //获取黑名单
  getBlackRecordsByName(params) {
    return request({
      url: REST_SERVICE.agencyUser.getBlackRecordsByName,
      method: 'get',
      params,
    });
  },

  deleteInstitutionalUser(data) {
    //删除企业用户
    return request({
      url: REST_SERVICE.agencyUser.deleteInstitutionalUser,
      method: 'post',
      data,
    });
  },
  addToBlackList(data) {
    //用户加入黑名单操作
    return request({
      url: REST_SERVICE.agencyUser.addToBlackList,
      method: 'post',
      data,
    });
  },
  removeFromBlackList(data) {
    //用户移除黑名单操作
    return request({
      url: REST_SERVICE.agencyUser.removeFromBlackList,
      method: 'post',
      data,
    });
  },
  // 获取所有角色列表
  getRoleList(params) {
    return request({
      url: REST_SERVICE.uums.getRoleList,
      method: 'get',
      params,
    });
  },
  // 获取已分配角色列表
  getByLoginName(params) {
    return request({
      url: REST_SERVICE.uums.getByLoginName,
      method: 'get',
      params,
    });
  },
  // 修改用户角色
  updateUserRole(data) {
    return request({
      url: REST_SERVICE.uums.updateUserRole,
      method: 'post',
      data,
    });
  },
  // 获取用户机构
  organization(params) {
    return request({
      url: REST_SERVICE.uums.organization,
      method: 'get',
      params,
    });
  },
  // 修改用户信息
  save(data) {
    return request({
      url: REST_SERVICE.agencyUser.saveCompany,
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      data,
    });
  },
  // 新增企业用户
  addUser(data) {
    return request({
      url: REST_SERVICE.ca.addInstitutionalUser,
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    });
  },
  findAgentsByCompanyId(params) {
    return request({
      url: REST_SERVICE.ca.findAgentsByCompanyId,
      method: 'post',
      params,
    });
  },
  agentUserBindCompany(params) {
    return request({
      url: REST_SERVICE.ca.agentUserBindCompany,
      method: 'post',
      params,
    });
  },
  delAgent(params) {
    return request({
      url: REST_SERVICE.ca.delAgent,
      method: 'post',
      params,
    });
  },
};
export default publicUserService;
